module.exports = __webpack_public_path__ + "img/product_background.d166138e.jpg";